import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { DeleteOrtCommandServiceModule } from '..';
import { DeleteOrtCommandComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    DeleteOrtCommandServiceModule
  ],
  declarations: [DeleteOrtCommandComponent],
  exports: [DeleteOrtCommandComponent],

})
export class DeleteOrtCommandComponentModule { }
